/* eslint-disable global-require */
import React from 'react'
import { connect } from 'react-redux'
import { doUploadHistory } from 'actions/attachments'
import Modal from 'shared/components/ui/Modal'
import { Button } from 'util/ui'

const DebugUploaded = ({ url, onClose }) => {
  return (
    <div>
      <p>{url}</p>
      <br />
      <Button onClick={onClose} primary size="large">
        Close
      </Button>
    </div>
  )
}
class DebugButton extends React.Component {
  state = {}

  startUpload = () => {
    console.log(this.modal)
    this.modal.open()
    this.setState({ stage: 'uploading', data: null })
    this.props.doUploadHistory().then(data => {
      console.log(data)
      this.setState({ stage: 'uploaded', data })
    })
  }

  closeModal = () => {
    this.modal.close()
    this.setState({ stage: 'uploading', data: null })
  }

  render() {
    const { stage, data } = this.state
    const { as } = this.props
    const Component = as || 'a'
    const headers = {
      uploading: 'Sending debug data',
      uploaded: 'Debug data uploaded',
      default: 'Debug data',
    }
    return (
      <Modal
        ref={node => (this.modal = node)}
        header={headers[stage] || headers.default}
        content={
          data ? (
            <DebugUploaded url={data.url} onClose={this.closeModal} />
          ) : (
            'Uploading...'
          )
        }
        basic
        cancelButton={false}
        confirmButton={false}
        trigger={
          <Component onClick={this.startUpload}>Send debug info</Component>
        }
        mobileWidth="eight"
        tabletWidth="eight"
        desktopWidth="eight"
        wideDesktopWidth="eight"
      />
    )
  }
}

const perform = {
  doUploadHistory,
}

export default connect(null, perform)(DebugButton)
